export default new Map([
    ['PreEvaScrubDue', 'Pre-EVA<br/>Scrub due after'],
    ['AnnualChangeOut', 'Annual ChangeOut'],
    ['Charge', ' Charge'],
    ['CheckOut', ' CheckOut'],
    ['CrewmemberAssigned', 'Crewmember Assigned'],
    ['CycleNumber', 'Initial Cycles'],
    ['DaysInSaferBatteryAdapter', 'Days In Safer Adapter'],
    ['Date', ''],
    ['Dcm', 'DCM'],
    ['Due', 'due'],
    ['due', ' due'],
    ['Dump', 'Dump'],
    ['EcwsId', 'eCWS ID'],
    ['EmuSN', 'EMU Serial'],
    ['EstimatedAutocycle', 'Estimated Autocycle, Recharge, and Checkout'],
    ['Fill', ' Fill'],
    ['First', 'First '],
    ['full', 'Full '],
    ['Full', 'Full '],
    ['GN2Check', 'GN2 Check'],
    ['GreaseCirculate', 'Grease / Circulate'],
    ['GroundCalibration', 'Ground Calibration'],
    ['GroundCycles', 'Ground Cycles'],
    ['HelmetInstallExpiration', 'Helmet Install Expiration'],
    ['hut', 'HUT '],
    ['Hut', 'HUT '],
    ['IeuLocation', 'IEU Location'],
    ['InstalledInSaferAdapter', 'In SAFFER Adapter'],
    ['Last', 'Last '],
    ['Last InstalledInSaferBatteryAdapter', 'Last Install In SAFER Adapter'],
    ['Last RemovedFromSaferBatteryAdapter', 'Last removal from SAFER Adapter'],
    ['Lcvg', 'LCVG'],
    ['MetoxRegeneration', 'METOX Regeneration'],
    ['ORingChange', 'O-Ring Change'],
    ['ORingExpiration', 'O-Ring Expiration'],
    ['partial', 'Partial '],
    ['Partial', 'Partial '],
    ['Pia', 'PIA'],
    ['PostEva', 'Post-EVA<br/>'],
    ['PowerCycle', 'Power Cycle'],
    ['Pwr', 'PWR'],
    ['RemoveReplace', ' R/R '],
    ['Reset', ' Reset'],
    ['SaferTm', 'SAFER TM'],
    ['Sop', 'SOP'],
    ['SserAltId', 'SSER Alt ID'],
    ['SserPriId', 'SSER Pri ID'],
    ['SserSN', 'SSER Serial'],
    ['Start', ' start'],
    ['TapeInstall', 'Tape Install'],
    // the space in 'Tape InstallExpiration' is needed and I don't know why
    ['Tape InstallExpiration', 'Tape Install Expiration'],
    ['TakDataCollection', 'TAK Data Collection'],
    ['TakDataApproval', 'TAK Data Approval'],
    ['UseCount', 'Uses'],
    ['UsesAvailable', 'Uses Available'],
    ['water', 'H<sub>2</sub>O '],
    ['Water', 'H<sub>2</sub>O '],
    ['Wlvta', 'WLVTA'],
    ['wlvta', 'WLVTA']
]);
